import { useApi, createApiHook } from "../utils/apiUtils";

const FALLBACK_FILENAME_PREFIX = "informe_estados_cuestionarios";

const extractFilename = (headers, fallback) => {
  const disposition = headers?.["content-disposition"] || "";

  const match = disposition.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);

  if (!match) return fallback;

  try {
    return decodeURIComponent(match[1]);
  } catch (error) {
    return match[1];
  }
};

const triggerBrowserDownload = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = filename;

  document.body.appendChild(link);
  link.click();
  link.remove();

  window.URL.revokeObjectURL(url);
};

const normalizeApplicationIds = (applicationIds) => {
  const values = Array.isArray(applicationIds) ? applicationIds : [applicationIds];

  return [...new Set(values.map((id) => Number(id)).filter((id) => Number.isInteger(id) && id > 0))];
};

const useDownloadAssignmentsStatusReport = () => {
  const { apiDownload } = useApi();
  const useApiState = createApiHook(null);

  const { data, error, loading, startLoading, setResponse } = useApiState();

  const downloadAssignmentsStatusReport = async (applicationIds) => {
    const normalizedApplicationIds = normalizeApplicationIds(applicationIds);

    if (normalizedApplicationIds.length === 0) {
      const selectionError = new Error("Debe seleccionar al menos una aplicación");

      setResponse({
        data: null,
        error: selectionError,
      });

      throw selectionError;
    }

    startLoading();

    const isMultipleApplicationsRequest = Array.isArray(applicationIds);

    const endpoint = isMultipleApplicationsRequest
      ? "/aplicaciones/assignments_status_report"
      : `/aplicaciones/${normalizedApplicationIds[0]}/assignments_status_report`;

    const requestConfig = isMultipleApplicationsRequest
      ? {
          method: "post",
          data: {
            application_ids: normalizedApplicationIds,
          },

          timeout: 120000,
        }
      : undefined;

    const response = await apiDownload(endpoint, "Error al descargar el informe de estados", requestConfig);

    if (response?.error) {
      setResponse({
        data: null,
        error: response.error,
      });

      throw new Error(response.error?.message || "Ocurrió un error al descargar el informe de estados");
    }

    const fallbackFilename = isMultipleApplicationsRequest
      ? `${FALLBACK_FILENAME_PREFIX}_${normalizedApplicationIds.length}_aplicaciones.xlsx`
      : `${FALLBACK_FILENAME_PREFIX}_${normalizedApplicationIds[0]}.xlsx`;

    const filename = extractFilename(response.headers, fallbackFilename);

    triggerBrowserDownload(response.data, filename);

    const result = {
      data: {
        filename,
        applicationIds: normalizedApplicationIds,
      },
      error: null,
    };

    setResponse(result);

    return result;
  };

  return {
    downloadAssignmentsStatusReport,
    data,
    error,
    loading,
  };
};

export default useDownloadAssignmentsStatusReport;
